module.exports = "/_next/static/images/32620e035ae78ed3393cdc92b2066eb3-card-and-phone-3d-xs@2x.jpg";